import React, { useMemo, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import { Text } from 'v3/components';
import { usePermission } from 'hooks';
import Input from 'v3/components/Input';
import Button from 'v3/components/Button';
import PlusMinus from 'v3/components/PlusMinus';

const restrictedViewCards = ['CargonRevenue'];

export default function Indicators({
  personalizedDashboardOptions,
  setPersonalizedDashboardOptions,
}) {
  const [indicatorFilter, setIndicatorFilter] = useState('');
  const hasPermission = usePermission('SUPER_ADM');
  const availableOptions = useMemo(() => {
    const mappedOptions = [...personalizedDashboardOptions]
      .sort((a, b) => (a.title > b.title ? 1 : -1))
      .map((item, idx) => ({ ...item, id: idx }));

    if (!hasPermission) {
      return mappedOptions.filter((item) => !restrictedViewCards.includes(item.component));
    }

    return mappedOptions;
  }, [hasPermission, personalizedDashboardOptions]);

  const filteredOptions = useMemo(() => {
    if (!indicatorFilter) {
      return availableOptions;
    }

    return availableOptions.filter((item) =>
      item.title.toLowerCase().includes(indicatorFilter.toLowerCase()),
    );
  }, [availableOptions, indicatorFilter]);

  const options = useMemo(
    () => ({
      first: filteredOptions.filter((_, idx) => idx < filteredOptions.length / 2),
      last: filteredOptions,
    }),
    [filteredOptions],
  );

  const allSelected = availableOptions.length > 0 && availableOptions.every((item) => item.value > 0);

  function handleToggleSelectAll() {
    setPersonalizedDashboardOptions(
      personalizedDashboardOptions.map((component) => {
        if (restrictedViewCards.includes(component.component) && !hasPermission) return component;
        return { ...component, value: allSelected ? 0 : component.value > 0 ? component.value : 1 };
      }),
    );
  }

  return (
    <Row>
      <Col xs={12} className="mb-3 d-flex align-items-center justify-content-between">
        <Text color="dark_blue" type="subtitle" weight={600}>
          Indicadores
        </Text>
        <div className="d-flex align-items-center justify-content-end" style={{ gap: '8px' }}>
          <Button
            variant={allSelected ? 'danger' : 'primary'}
            outlined
            size="sm"
            style={{ whiteSpace: 'nowrap' }}
            onClick={handleToggleSelectAll}
          >
            <Text weight="500" type="regular">
              {allSelected ? 'Desmarcar todos' : 'Selecionar todos'}
            </Text>
          </Button>
          <div style={{ width: '220px', flexShrink: 0 }}>
            <Input
              placeholder="Procure um indicador"
              value={indicatorFilter}
              onChange={({ target }) => setIndicatorFilter(target.value)}
              style={{ height: '36px' }}
              fontSize="13px"
              placeholderSize="13px"
              autoFocus
            />
          </div>
        </div>
      </Col>
      <Col xs={6}>
        {options.first.map((item) => (
          <Col xs={12} className="mb-3 p-0" key={item.component}>
            <PlusMinus
              title={item.title}
              value={item.value}
              onChange={(value) => {
                setPersonalizedDashboardOptions(
                  personalizedDashboardOptions.map((component) => {
                    if (item.title === component.title) return { ...component, value };
                    return component;
                  }),
                );
              }}
            />
          </Col>
        ))}
      </Col>
      <Col xs={6}>
        {options.last.map((item, idx) => {
          if (idx >= options.first.length)
            return (
              <Col xs={12} className="mb-3 p-0" key={item.component}>
                <PlusMinus
                  title={item.title}
                  value={item.value}
                  onChange={(value) => {
                    setPersonalizedDashboardOptions(
                      personalizedDashboardOptions.map((component) => {
                        if (item.title === component.title) return { ...component, value };
                        return component;
                      }),
                    );
                  }}
                />
              </Col>
            );
        })}
      </Col>
    </Row>
  );
}
